import { useState, useEffect } from 'react';
import { View, Platform, ActivityIndicator } from 'react-native';
import axios from 'axios';
import PrivateRoutes from './private';
import PublicRoutes from './public';
import ErrorBottomSheet from '../sharedComponents/ErrorBottomSheet/ErrorBottomSheet';
import {  logout, updateUserDetails, userAuthenticated } from '../store/slices/authSlice';
import { baseUrl, endpoints } from '../api/apis';

import {useAppDispatch , useAppSelector } from '../store/hooks'
import {showErrorSheet} from '../store/slices/errorSlice'
import { checkColor, getParamsLink, parseParameters, removeQueryParams, setAppHeader } from '../utils/utils';
import { updatePartnerParams } from '../store/slices/platformSlice';
import { LENDER_ID, PLATFORM_NAME } from '@app/types/regix';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { initAmplitude, trackEvent } from '@app/utils';
import { config } from '@voltmoney/micro-frontend';
import { navigationRef ,isIframeCheck} from '../utils/utils';
import useSingleRemoteConfig from '@app/hooks/useSingleRemoteConfig';
import handleApiErr from '@app/helper/handleApiErr';
import { updateisLMSUser } from '@app/store/slices/commonSlice';

let crashlytics: typeof import("@react-native-firebase/crashlytics").default | undefined;
if (typeof window === "undefined") {
  crashlytics = require("@react-native-firebase/crashlytics").default;
}

export default function AppRoutes({setIsUserLoggedIn}) {
  const {auth, platformParams} = useAppSelector(state => state);
  const [isLoading , setIsLoading] = useState(true)
  const errorSheetDetail = useAppSelector(state => state.errorSheet);
  const dispatch = useAppDispatch();
  const [tokenFromStorage , setTokenFromStorage] = useState<null | string>(null)
  const {configValue:callData} =  useSingleRemoteConfig('contact_support_number_pre_dashboard')
  const {configValue:lmsCallData} =  useSingleRemoteConfig('contact_support_number')
  const {configValue:waData} = useSingleRemoteConfig('contact_support_number_whatsapp')
  useEffect(()=>{
    if (Platform.OS === 'web') {
      document.title = 'Volt - Unlock cash from your mutual funds saving'; // Explicitly set the title
    }
      if(!auth.isAuthenticated || auth?.userDetails===null) {
        return
      };
      const creditId = auth?.userDetails?.linkedCredits[0]?.creditId || null;
      const currentStepName = auth?.userDetails?.linkedApplications[0]?.currentStepId 
      const isLmsUser =  creditId !== null || currentStepName === null
      const callNumber = isLmsUser ? lmsCallData : callData
      if(callNumber){
      let updateData = callNumber
       if(Platform.OS === 'web'){
        const params = parseParameters(window?.location?.href);
        updateData = params?.callData || callNumber
       }
        dispatch(updatePartnerParams({callData:updateData}))
      }
      if(waData){
        let updateData = waData
         if(Platform.OS === 'web'){
          const params = parseParameters(window?.location?.href);
          updateData = params?.waData || waData
         }
          dispatch(updatePartnerParams({waData:updateData}))
        }
      
  },[callData,waData ,lmsCallData,auth?.isAuthenticated,auth?.userDetails])


  useEffect(() => {
    let params = {};
    if(Platform.OS === 'web'){
      params = parseParameters(window?.location?.href);
    }
    const fetchUserInfo = () => {
      const url = endpoints.userInfo;
      axios
        .post(url, { onboardingPartnerCode: params?.ref ||'' })
        .then(async res => {
          if(Platform.OS !== 'web' && crashlytics){
            // init crashlytics with accountId and phoneNumber
            crashlytics().setUserId(res?.data?.linkedApplications[0]?.accountId)
            crashlytics().setAttribute('phoneNumber', res?.data?.user?.phoneNumber)
          }
          initAmplitude({userId : res?.data?.linkedApplications[0]?.accountId})
          dispatch(updateUserDetails(res?.data));
          setIsUserLoggedIn(res?.data);
          const creditId = res?.data?.linkedCredits[0]?.creditId || null; // check if creditId is present then navigate to splash screen for LMS flow
          const currentStepName = res?.data?.linkedApplications[0]?.currentStepId
          if (creditId !== null || currentStepName === null) {
            dispatch(updateisLMSUser({ isLMSUser: true }));
          }
          else{
            dispatch(updateisLMSUser({ isLMSUser: false }));
          }
          // console.log('navigationRefAppRoutes',navigationRef)
        })
        .catch(err => {
          // LogOutUser();
          if(handleApiErr(err)){
          dispatch(
            showErrorSheet({
              isErrorSheetVisible: true,
              errorMessage: err?.data?.message,
              closeOnBackdropPress: true,
              errorType: err?.data?.voltErrorCode || err?.data?.statusCode,
              errorHeading:  err?.data?.header,
            }),
          );
          }
        }).finally(()=>{
          setIsLoading(false)
        })
    };

    const checkAuthStatus = async()=>{
      let accessToken=null
      if(Platform.OS === 'web'){
        const isAccessTokenInCookiPreset = document.cookie.split(';').some((item) => item.trim().startsWith('access_token='));
        if(isAccessTokenInCookiPreset){
          const accessTokenCookie = document.cookie.split(';').find((item) => item.trim().startsWith('access_token='));
          accessToken = accessTokenCookie?.split('=')[1];
          if(Boolean(accessToken)){
            setAppHeader(accessToken)
          }
        }
        if(!isAccessTokenInCookiPreset && isIframeCheck()){
           accessToken = await AsyncStorage.getItem('access_token');
           if(Boolean(accessToken)){
            setAppHeader(accessToken)
          }
         }
      }
      else{
        accessToken = await AsyncStorage.getItem('access_token');
      }
      if (auth.isAuthenticated && Boolean(accessToken)) {
        setAppHeader(accessToken)
        fetchUserInfo();
      }
      if (accessToken === null) {
        setIsUserLoggedIn({})
        dispatch(logout())
      }
      else {
        if (accessToken) {
          setTokenFromStorage(accessToken)
        }
      }
      setTimeout(()=>{
        setIsLoading(false)
      },Platform.OS === 'web' ? 1000 : 0)
    }
    
    checkAuthStatus()
    if(Platform.OS === 'web'&&auth.isAuthenticated){
      const url =  window.location.href;
      const params = parseParameters(window.location.href);
      console.log('CHECKPARAMS',params)
      const isPartnerPlatform = url.toLowerCase().includes('partnerplatform');
      const isMarketing = url.toLowerCase().includes('marketing');
      const isKYCRedirect = url.includes('bajajKyc');
      const isIframe = params?.isIframe;
      const platform = params?.platform;
      const isfromTDL = platform === PLATFORM_NAME.TDL
      const isFromDsp = platform === LENDER_ID.DSP
      const isFromBajaj = platform === LENDER_ID.BAJAJ
      const isFromPhonePe = platform === PLATFORM_NAME.PHONEPE
      const showVoltDefaultHeader = !((isMarketing || isIframe) || platform ==="REDVISION" || platform==="JUPITER")
      const obj={showVoltDefaultHeader,...params,isPartnerPlatform,isFromPhonePe,isFromDsp, isFromBajaj,isMarketing,isKYCRedirect,isfromTDL}
      dispatch(updatePartnerParams(obj))
    }
  }, [auth?.accessToken, auth.isAuthenticated, dispatch]);

  const domainCheck = (url:string) => {
    const isVoltMoneyUrl = url?.includes('voltmoney.in');
    const isLocalhostUrl = url?.includes('localhost:3000') || url?.includes('localhost:8080');
    return isVoltMoneyUrl || isLocalhostUrl;
  }
  useEffect(()=>{
    return // because its loading from legacy code
    if(Platform.OS!=='web' && !platformParams?.isPLJ){
      console.log('NOT WEB PARAMS')
      return
    }
    const url = window.location.href;
    const params = parseParameters(window.location.href);
    const {isIframe,isCheckLimitMFC,t:short_token,leadtoken,trackingId,plkTK,platform,ssoToken}= params
    const parentDomain = window?.document?.referrer;
    let _url2 = removeQueryParams(url, ['t', 'plj'])
    let domCheck = domainCheck(parentDomain);
    console.log('domCheck',domCheck,isIframeCheck())
    if(platform === 'PHONEPE') {
      _url2 += '&showHome=false'
    }
    if(ssoToken) {
      axios.post(endpoints.getAuthToken, {ssoToken: ssoToken}).then((res)=>{
          console.log("sso token success")
      }).catch((err)=>{
        console.log('err',err)
      })
    }
    else if(isCheckLimitMFC && leadtoken) {
      AsyncStorage.setItem('lead_token', leadtoken);
      AsyncStorage.setItem('CONTEXT', 'VIEW_DETAIL');
      navigation.navigate("CHECK_LIMIT_MFC_INIT",{isCheckLimitMFC});
    } else if(short_token){
      setAppHeader(short_token)
      window.parent.postMessage(`PLJ_SHORT_TOKEN_TO_LONG_TOKEN_GENERATION_INITIATED`, '*');
      const refreshUrl = endpoints.refreshToken
      axios.post(refreshUrl,{})
      .then(async res => {
        window.parent.postMessage(`PLJ_SHORT_TOKEN_TO_LONG_TOKEN_GENERATION_COMPLETED`, '*');
        setAppHeader(res?.data?.jwt)
        if(platform) {
            await AsyncStorage.setItem('access_token', res.data.jwt , ()=> {
              window.open(`${baseUrl}/partnerPlatform${getParamsLink(_url2)}`, '_self');
            });
        } else {
            await AsyncStorage.setItem('access_token', res.data.jwt , ()=> {
              window.open(`${baseUrl}/${getParamsLink(_url2)}`, '_self');
            });
        }
      }).catch((err)=>{
        console.log('short_token error',err)
      })
    }   else if(
      plkTK 
      && domCheck 
      && isIframeCheck()
  ) { 
      setAppHeader(plkTK)
      window.parent.postMessage(`PLJ_SHORT_TOKEN_TO_LONG_TOKEN_GENERATION_INITIATED`, '*');
      axios.post(endpoints.refreshToken,{})
          .then(async res => {
              if(res.status === 200) {
                  window.parent.postMessage(`PLJ_SHORT_TOKEN_TO_LONG_TOKEN_GENERATION_COMPLETED`, '*');
                  if(res?.data?.jwt) {
                      setAppHeader(res?.data?.jwt)
                      dispatch(userAuthenticated({accessToken: res?.data?.jwt}));
                  }
              } else {
                      trackEvent("PLJ_SHORT_TOKEN_TO_LONG_TOKEN_GENERATION_FAILED", {
                      trackingId: trackingId,
                      failedCause: 'Failed to get new short JWT from response'
                  })
              }
          })
          .catch((err)=>{
            console.log('plktoken error',err)
          })
  } else {
      window.parent.postMessage(`PLJ_SHORT_TOKEN_TO_LONG_TOKEN_GENERATION_INITIATED`, '*');
      window.addEventListener('message', async function (event) {
          try {
              if (event.data && event.data.hasOwnProperty('jwt')) {
                  // Short-lived token set temporarily. Call for long-lived token.
                  // axios.defaults.headers.common.Authorization = 'Bearer ' + event.data.jwt;
                  setAppHeader(event.data.jwt)
                  const response = await axios.post(endpoints.refreshToken,{});
                  setAppHeader(response.data.jwt)
                  if (response?.data?.jwt) {
                      if (Platform.OS === "web") {
                          window.parent.postMessage(`PLJ_SHORT_TOKEN_TO_LONG_TOKEN_GENERATION_COMPLETED`, '*');

                      }
                      await AsyncStorage.setItem('accessToken', response.data.jwt, () => {
                          // navigation.navigate('SPLASH_SCREEN', {trackingId:  trackingId});
                      });
                  } else {
                      trackEvent("PLJ_SHORT_TOKEN_TO_LONG_TOKEN_GENERATION_FAILED", {
                          trackingId: trackingId,
                          failedCause: 'Failed to get new JWT from response'
                      })
                  }
              } else {
                trackEvent("PLJ_SHORT_TOKEN_TO_LONG_TOKEN_GENERATION_FAILED", {
                      trackingId: trackingId,
                      failedCause: 'Event data does not contain JWT'
                  })
              }
          } catch (error) {
              trackEvent("PLJ_SHORT_TOKEN_TO_LONG_TOKEN_GENERATION_FAILED", {
                  trackingId: trackingId,
                  failedCause: 'Error processing message event'
              })
          }
      });
  }
  },[])

 

  useEffect(() => {
    // initialiseing the amplitude for signedout routes
    initAmplitude({ userId: '', token: config.AMPLITUDE_CONFIG })
  }, [])

  if (isLoading) {
    return (
      <View style={{ flex: 1, backgroundColor : "white" ,alignItems: 'center', justifyContent: 'center' }}>
        <ActivityIndicator size={12} color={checkColor("#1434CB")} />
      </View>
    )
  }

  return (
    <>
      {auth?.isAuthenticated && tokenFromStorage && auth?.userDetails!==null ? (
        <PrivateRoutes userDetails={auth?.userDetails}  />
      ) : (
        <PublicRoutes />
      )}
      {errorSheetDetail?.isErrorSheetVisible && <ErrorBottomSheet />}
    </>
  );
}